export async function encryptPassword(publicKeyPem, password) {
  try {
    // Remove header, footer, and line breaks
    const pemContents = publicKeyPem
      .replace('-----BEGIN PUBLIC KEY-----', '')
      .replace('-----END PUBLIC KEY-----', '')
      .replace(/\n/g, '');

    // Convert base64 to ArrayBuffer
    const binaryDer = Uint8Array.from(
      atob(pemContents),
      (char) => char.charCodeAt(0)
    );

    // Import key
    const cryptoKey = await window.crypto.subtle.importKey(
      'spki',
      binaryDer,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      false,
      ['encrypt']
    );

    // Encode password
    const encodedPassword = new TextEncoder().encode(password);

    // Encrypt
    const encryptedBuffer = await window.crypto.subtle.encrypt(
      { name: 'RSA-OAEP' },
      cryptoKey,
      encodedPassword
    );

    // Convert ArrayBuffer to Base64
    const encryptedArray = new Uint8Array(encryptedBuffer);
    const encryptedBase64 = btoa(
      String.fromCharCode(...encryptedArray)
    );

    return encryptedBase64;
  } catch (error) {
    console.error('Encryption failed:', error);
    throw new Error('Password encryption failed');
  }
}
